/**
 * Używane w rezerwacji grupowej, gdy próbuje się stworzyć rezerwację, a nie ma już wolnych pokojów
 */
export class NoAvailableRoomsException extends Error {
    constructor() {
        super('No available rooms');
        this.name = "NoAvailableRoomsException";
    }
}